export default __webpack_public_path__ + "static/media/sign-in-background.d1f47886.png";